export const addMobileResizeListener = (callback, mobileBreakpoint = 750) => {
    const handleResize = () => {
        callback(window.innerWidth < mobileBreakpoint);
    };

    handleResize(); // initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
};

export const addShortMobileResizeListener = (callback, heightBreakpoint = 350) => {
    const handleResize = () => {
        callback(window.innerHeight < heightBreakpoint);
    };

    handleResize(); // Run once initially
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
};
